import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { fetchPointTable } from "../../../api";
import cskImg from "../../../../assets/images/csk.png";
import rrImg from "../../../../assets/images/rr.png";
import dcImg from "../../../../assets/images/dc.png";
import kkrImg from "../../../../assets/images/kkr.png";
import kxpImg from "../../../../assets/images/kxp.png";
import miImg from "../../../../assets/images/mi.png";
import srhImg from "../../../../assets/images/srh.png";
import rcbImg from "../../../../assets/images/rcb.png";
import assetify from "@quintype/framework/assetify";

import styles from "./styles.m.css";

const IplPointTable = ({ accentColor }) => {
  const [matchList, setData] = useState([]);

  useEffect(() => {
    fetchPointTable().then(list => {
      setData(list);
    });
  }, []);
  const pointList = get(matchList, ["data", "points", "rounds", 0, "groups", 0, "teams"], []);
  return (
    <div className={styles["base"]}>
      <div className={`container ${styles["point-table"]}`}>
        <h1>Points Table</h1>
        <table>
          <tr>
            <th>Team</th>
            <th>PLD</th>
            <th>Won</th>
            <th>Lost</th>
            <th>Tied</th>
            <th>N/R</th>
            <th>Net RR</th>
            <th>Pts</th>
          </tr>
          {pointList.length > 0 &&
            pointList.map((list, index) => {
              let imageValue = miImg;

              if (list.short_name === "CSK") {
                imageValue = cskImg;
              }

              if (list.short_name === "RCB") {
                imageValue = rcbImg;
              }

              if (list.short_name === "RR") {
                imageValue = rrImg;
              }

              if (list.short_name === "KKR") {
                imageValue = kkrImg;
              }

              if (list.short_name === "SRH") {
                imageValue = srhImg;
              }

              if (list.short_name === "DC") {
                imageValue = dcImg;
              }

              if (list.short_name === "KXIP") {
                imageValue = kxpImg;
              }

              return (
                <tr key={index}>
                  <td>
                    <table className={styles["inner-table"]}>
                      <tr>
                        <td>
                          <img alt={list.short_name} src={assetify(imageValue)} className={styles["img-view"]} />
                        </td>
                        <td>{list.short_name}</td>
                      </tr>
                    </table>
                  </td>
                  <td>{list.played}</td>
                  <td>{list.won}</td>
                  <td>{list.lost}</td>
                  <td>{list.tied}</td>
                  <td>{list.no_result}</td>
                  <td>{list.net_run_rate}</td>
                  <td>{list.points}</td>
                </tr>
              );
            })}
        </table>
      </div>
    </div>
  );
};

IplPointTable.propTypes = {
  accentColor: PropTypes.string
};

export default IplPointTable;
